jQuery( $ => {
	/**
	 * Trigger accordion.
	 */
	$( '.open-trigger' ).on( 'click', function() {
		$( this ).toggleClass( 'open' );
	} );
} );
